// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"100":"a9ccefe1","160":"ff04e5b7","176":"1bcd5ea7","501":"c3463f9e","537":"f0b6ceab","575":"dc8b1fe6","580":"c5e15eb1","614":"c117021c","647":"3ef1363a","666":"767ceeed","893":"a404f64c","895":"a56fca18","950":"76fd65ff","962":"86d80330"}[chunkId] + ".js";
};